import styled from 'styled-components';
import { Col } from 'reactstrap';
import card from '@bit/wavfichacerta.fichacerta.cards.card';

export const Card = styled(card)`
  background-color: ${props => props.theme.color_white};
  position: relative;
  border-radius: 12px;
  border: 1px solid rgba(21, 43, 78, 0.06);
  box-shadow: 0 4px 24px rgba(21, 43, 78, 0.06);
  padding: 1.25rem;
  margin-bottom: 0.75rem;

  &.request-resume-applicant-card {
    overflow: visible;
  }

  @media (max-width: 800px) {
    isolation: isolate;
    border-left: 3px solid ${props => props.theme.color_purple};
    box-shadow: 0 2px 12px rgba(21, 43, 78, 0.1);
    padding: 12px 12px 10px;
    margin-bottom: 12px;

    p {
      font-size: 11px;
      line-height: 1.3;
    }
    b {
      text-transform: uppercase;
      font-weight: 600;
    }
  }
`;

export const ApplicantHeaderDesktop = styled.div`
  @media (max-width: 800px) {
    display: none;
  }
`;

export const ApplicantHeaderMobile = styled.div`
  display: none;

  @media (max-width: 800px) {
    display: block;
    position: relative;
    /* Acima da linha de produtos (irmã), para o Popper do dropdown não ficar por baixo dos cards */
    z-index: 24;
    padding: 2px 2px 8px;
  }
`;

export const ApplicantMobileHeaderTop = styled.div`
  display: none;

  @media (max-width: 800px) {
    display: flex;
    flex-wrap: nowrap;
    align-items: flex-start;
    justify-content: space-between;
    gap: 10px;
  }
`;

export const ApplicantMobileHeaderText = styled.div`
  flex: 1 1 0%;
  min-width: 0;
  max-width: 100%;
  overflow: hidden;
`;

export const ApplicantNameLine = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  flex-wrap: nowrap;
  min-width: 0;
  width: 100%;
  max-width: 100%;
  overflow: hidden;
`;

/** Rótulo "Nome:" na mesma linha do valor (só mobile — bloco pai some no desktop) */
export const ApplicantNameLabel = styled.span`
  flex-shrink: 0;
  font-size: 12px;
  line-height: 1.35;
  color: #64748b;
  margin: 0;
`;

export const ApplicantNameValue = styled.span`
  color: #152b4e;
  font-weight: 700;
  font-size: 12.5px;
  line-height: 1.35;
  flex: 1 1 auto;
  min-width: 0;
  max-width: 100%;
  display: block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: normal;
  overflow-wrap: normal;
`;

export const ColSpaceBetween = styled(Col)`
  display: flex;
  justify-content: space-between;
  align-items: flex-end;

  @media (max-width: 800px) {
    align-items: flex-start;
  }
`;

export const PTitle = styled.p`
  font-size: 12.5px;
  color: ${props => props.theme.color_gray};
  margin-bottom: 0;

  @media (max-width: 800px) {
    font-size: 12px;
    line-height: 1.35;
    color: #64748b;
  }
`;

export const BoldCards = styled.b`
  font-weight: 600;
`;

export const IconsContainer = styled.div`
  display: flex;
  flex-direction: row;
  height: 1.5rem;
  align-items: center;
  gap: 12px;

  @media (max-width: 800px) {
    position: static;
    height: auto;
    flex-shrink: 0;
    align-items: center;
    gap: 4px;
    margin-top: 1px;
  }
`;

/** Botões de ação rápida no cabeçalho mobile (substitui o dropdown ⋮) */
export const ApplicantMobileIconBtn = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 4px;
  margin: 0;
  border: none;
  border-radius: 8px;
  background: transparent;
  color: #152b4e;
  cursor: pointer;
  flex-shrink: 0;
  line-height: 0;
  -webkit-tap-highlight-color: transparent;

  svg {
    display: block;
    width: 16px;
    height: 16px;
  }

  img {
    display: block;
    width: 16px;
    height: 16px;
    object-fit: contain;
  }

  &:disabled {
    opacity: 0.45;
    cursor: not-allowed;
  }

  &:active:not(:disabled) {
    opacity: 0.75;
  }
`;

export const Icon = styled.div`
  width: 1.4rem;
  display: flex;
  align-items: center;

  & > img {
    transition: .2s;
    height: 1.1rem;
  }

  & > svg {
    transition: .2s;
    height: 1.4rem;
  }

  & > svg, polygon, path {
    fill: #152b4e;
  }

  $:hover {
    & > img {
      transform: scale(1.2);
    }
  
    & > svg {
      transform: scale(1.2);
    }
  }
`;
